import OwnerModel from '../owner/owner-model';
import SectionModel from '../section/section-model';
import AppService from '../../services/app.service';
import ApiService from '../../services/api.service';
import MedialibraryModel from '../medialibrary/medialibrary-model';
import { ThemeDefault } from '../../components';

export default class AppModel {
    id: number;
    name: string;
    description: string;
    status: string;
    owner: any;
    ownerCaption: string;
    expireddate: any;
    theme: any;
    image: any;
    imageId: number;
    imageUrl: string;    
    section: any;
    
    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        let owner = datarow.owner?.data? new OwnerModel(datarow.owner?.data) : datarow.owner;
        this.owner = owner?.id;
        this.ownerCaption = owner?.name;
        this.expireddate = datarow.expireddate;
        this.theme = datarow.theme || ThemeDefault;
        this.image = datarow.image?.data?.map((d: any) => new MedialibraryModel(d))?.[0];
        this.imageId = this.image?.id;
        this.imageUrl = this.image? ((this.image.url?.startsWith('http')? '' : ApiService.svrUrl) + this.image.url) : '';
        let section = datarow.section?.data? new SectionModel(datarow.section?.data) : datarow.section;
        this.section = section?.id;

    } 

    public static endPoint: string = 'apps';
    public static endPointMedia: string = 'api::app.app';
    public static url: string = '/app';
    public static caption: string = 'Application';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        owner: +OwnerModel.getOwner(),
        ownerCaption: OwnerModel.getOwnerCaption(),      
        expireddate: AppService.dateCurrent(),
        theme: ThemeDefault,
        image: null,
        imageId: 0,
        imageUrl: '',
        section: null,
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
    ]
    
    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
    
    
}